import React from 'react';
import { BrowserRouter } from "react-router-dom";
import Router from './router';
import {ThemeProvider} from '@mui/material/styles';
import theme from "./core/components/layout/theme";


const App = () => {

  
  const app_environment = process.env.REACT_APP_ENVIRONMENT;
  console.log('REACT_APP_ENVIRONMENT:', app_environment);

  const REACT_APP_KNOWN_AUTHORITIES = process.env.REACT_APP_KNOWN_AUTHORITIES?.split(',') || [];


  console.log('HHHHHHHHHHHHHHHHHHHHHHHHHHHH', REACT_APP_KNOWN_AUTHORITIES)

  return (
    <>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Router/>
        </BrowserRouter>
      </ThemeProvider>
    </>
  )
};

export default App;
